const getters = {
    scoutingFilters: state => state.scouting_filters,
    scouting: state => state.scouting,
    scoutings: state => state.scoutings,
}

export default getters;
